import React from 'react'
import styles from './Buttons.module.css'

const Close = ({ onClick }) => (
  <button className={styles.close} onClick={onClick}>&times;</button>
)

export default Close
